<template>
	<div class="yixiaolie">

		<div class="headera">


			<el-date-picker size="mini" style="width: 250px;margin-right: 20px" value-format="yyyy-MM-dd" v-model="date1" type="daterange"
			 range-separator="-" start-placeholder="开始日期" end-placeholder="结束日期">
			</el-date-picker>

			<el-input style="width: 140px;font-size: 14px;margin-right: 20px" placeholder="活动名称" size="small" @keyup.enter.native="sousuo" v-model="center">
			</el-input>

			<div class="btngroup" style="margin-right: 20px">
				<el-radio size="mini" v-model="jiesuan" label="1" border>未结算</el-radio>
				<el-radio size="mini" v-model="jiesuan" label="2" border>已结算</el-radio>
			</div>



			<el-button type="warning" size="mini" icon="el-icon-search" @click="sousuo">搜索</el-button>


			<el-button type="warning" size="mini" style="margin-left: 20%;" @click="fenfn">分成设置</el-button>
		</div>


		<div style="padding-left: 10px;padding-right: 10px;box-sizing: border-box">
			<table class="table table-bordered table-hover" v-loading="loading2">
				<thead>
					<tr>
						<th>序号</th>
						<th>活动名称</th>
						<th>活动时间</th>
						<th>订单数</th>
						<th>结算金额</th>
						<th>结算状态</th>
						<th>操作</th>
					</tr>
				</thead>
				<tbody>
					<tr v-if="status">
						<td>暂无数据</td>
					</tr>
					<tr v-if="!status" v-for="(ta,index) in tabdata" :key="index">
						<td>{{index+1}}</td>
						<td>{{ta.group_name}}</td>
						<td>{{ta.start_time}}至{{ta.end_time}}</td>
						<td>{{ta.order_sum}}</td>
						<td>{{ta.real_settlement_money}}</td>
						<td>{{ta.status}}</td>
						<td style="color: #0099FF;cursor: pointer" @click="chakan(ta.id)">查看</td>
					</tr>

				</tbody>

			</table>


			<p style="color: #999;margin-bottom: 15px;font-size: 14px">共有{{zongt}}条数据</p>

			<div class="table-bottom">
				<div>
					<el-pagination @current-change="fanye" :page-size="pageone" background :current-page="curpage" layout="prev, pager, next"
					 :total="zongt">
					</el-pagination>
				</div>

			</div>
		</div>





	</div>
</template>

<script>
	export default {

		data() {
			return {
				loading2: false,
				jiesuan: '1',
				date1: '',
				pageone: 15,
				curpage: 1,
				zongt: 0,
				tabdata: '',
				center: '',
				status: '',
				token: ''

			}
		},
		methods: {
			fenfn: function() {
				//            onclick="javascript:location.href='renjies.html'"
				this.$router.push({
					name: 'renjies',

				})
			},
			chakan: function(id) {

				this.$router.push({
					name: 'yewujiesuan2',
					query: {
						aid: id
					}
				})

			},
			fanye: function(i) {
				let self = this;
				self.curpage = Number(i);
				self.gonggong()
			},
			sousuo: function() {
				let self = this;
				self.curpage = 1;
				self.gonggong()
			},
			gonggong: function() {
				let self = this;
				if (self.date1 != null) {
					let time1 = self.date1[0]
					let time2 = self.date1[1]
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + "saas/settlement/staff_settlement",
						data: {
							token: self.token,
							group_name: self.center,
							settlement_status: self.jiesuan,
							page: self.curpage,
							start_time: time1,
							end_time: time2
						},
						beforeSend: function(xhr) {
							self.loading2 = true
						},
						success: function(data) {
							self.loading2 = false
							if (data.status == 2) {
								self.status = true
								self.zongt = 0
							} else {
								self.status = false
								self.tabdata = data.data;
								self.zongt = data.map.count;
								self.curpage = Number(data.map.page);
								self.pageone = Number(data.map.pageone);
							}

						},
						error: function(data) {

							self.$message.error(`请求失败!`);
						}
					});
				} else {
					let time1 = ''
					let time2 = ''
					$.ajax({
						type: 'POST',
						url: process.env.apiUrl + "saas/settlement/staff_settlement",
						data: {
							token: self.token,
							group_name: self.center,
							settlement_status: self.jiesuan,
							page: self.curpage,
							start_time: time1,
							end_time: time2
						},
						beforeSend: function(xhr) {
							self.loading2 = true
						},
						success: function(data) {
							self.loading2 = false
							if (data.status == 2) {
								self.status = true
								self.zongt = 0
							} else {
								self.status = false
								self.tabdata = data.data;
								self.zongt = data.map.count;
								self.curpage = Number(data.map.page);
								self.pageone = Number(data.map.pageone);
							}

						},
						error: function(data) {

							self.$message.error(`请求失败!`);
						}
					});
				}


			},

		},
		mounted: function() {
			var self = this;
			//        self.centre_id={$centre_id}
			self.centre_id = $.cookie('centre_id')
			self.token = $.cookie('token')

			$.ajax({
				type: 'POST',
				url: process.env.apiUrl + "saas/settlement/staff_settlement",
				data: {
					token: self.token,
				},
				beforeSend: function(xhr) {
					self.loading2 = true
				},
				success: function(data) {
					console.log(data)
					self.loading2 = false;

					if (data.status == 2) {
						self.status = true
						self.zongt = 0
					} else {
						self.status = false
						self.zongt = data.map.count;
						self.curpage = data.map.page;
						self.pageone = Number(data.map.pageone);
						self.tabdata = data.data;
						self.head = data.head;
					}

				},
				error: function(data) {

					self.$message.error(`请求失败!`);
				}
			});







		}

	}
</script>

<style scoped>
	body .yixiaolie {
		/*font-size: 18px;*/
	}

	.headera {
		padding: 10px;
		display: flex;

		align-items: center;
	}

	.header {
		padding: 10px;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.tablebtnBox {

		display: flex;
		justify-content: space-between;
	}

	.tableBox {
		padding: 0 10px;

	}

	body,
	p {
		margin: 0;
		padding: 0;
		font-size: 11px;
	}

	.boxr {
		width: 224px;
		height: 54px;
		/*line-height: 1.08;*/
		/*background: green;*/
		box-sizing: border-box;
		padding-left: 20px;
		display: flex;
		display: -webkit-flex;
		align-items: center;
	}

	#app {
		width: 100%;
		height: 100vh;
		display: flex;
		display: -webkit-flex;
		flex-direction: column;
	}

	.mainBox {
		display: flex;
		display: -webkit-flex;
		flex: 1;


	}

	.fflex {
		display: flex;
		display: -webkit-flex;
	}

	.leftBox {
		width: 70px;
		height: 100%;
		background: #E6BE8A;
		border-radius: 10px 0 0 10px;
		box-sizing: border-box;
		padding-top: 30px;
		padding-bottom: 30px;

	}

	.rightBox {
		flex: 1;
		flex-direction: column;
	}

	.mainbox {
		flex: 1;
	}

	.bottombox {
		height: 40px;
		justify-content: center;
		align-items: center;
		color: #666;
		width: 100%;
		background: #f1f1f1;
	}

	.mainhead {
		display: flex;
		display: -webkit-flex;
		height: 43px;
		background: #f1f1f1;
		align-items: center;
		justify-content: space-between;
		box-sizing: border-box;
		padding-left: 8px;
		padding-right: 8px;
	}

	nav {
		width: 100%;
		height: auto;
		overflow-y: scroll;
		overflow-x: visible;
	}

	.navlist {
		height: 55px;
		justify-content: center;
		align-items: center;

	}

	.tubiaoc {
		display: inline;
		text-align: center;
	}

	.navimg {
		width: 28px;
		height: 28px;
	}

	.navinfo {
		color: #fff;
		margin-top: -2.5px;
	}

	.logotitle {
		font-size: 14px;
		color: #6355a2;
		margin-left: 15px;
		font-weight: 700;
		margin-top: 13px;
		letter-spacing: 0.5px;
	}

	.mainbox2 {
		flex-direction: column;
		flex: 1;
	}

	.headleft {
		height: 24px;
	}

	.headright {
		height: 24px;
		justify-content: flex-end;
		align-items: center;
	}

	.jumpindex {
		width: 55px;
		height: 24px;
	}

	.centername {
		line-height: 24px;
		margin-left: 10px;
	}

	.HeadPurBtn {
		padding: 3px 9px;
		border-radius: 13px;
		background: #E6BE8A;
		color: #fff;
	}

	.HeadHelpBtn {
		width: 50px;
		margin-left: 15px;
	}

	.inner_body {
		background: #f1f1f1;
	}



	.zaixiankef .el-dialog__body {
		padding: 10px 10px;

	}

	.zaixiankef .el-dialog__body p {
		font-size: 11px;
	}


	.zaixiankef .el-dialog .el-dialog__header {
		background: #E6BE8A;
		text-align: center;
		padding: 8px;
		/*border-radius: 10px 10px 0 0;*/

	}

	.zaixiankef .el-dialog .el-dialog__header .el-dialog__title {
		color: #fff;
		font-size: 18px;
	}

	.zaixiankef .el-dialog__headerbtn {
		top: 8px;
		right: 8px;
		font-size: 15px;
	}

	.zaixiankef .el-dialog__headerbtn .el-dialog__close {
		color: #fff;
	}

	.tanchuang2 .el-dialog__body {
		padding: 15px;
		height: 270px;
		overflow-y: scroll;
	}

	.tanchuang2 .el-dialog__footer {
		border-top: 1px solid #e5e5e5;
	}

	.clearfloat:after {
		display: block;
		clear: both;
		content: "";
		visibility: hidden;
		height: 0
	}

	.clearfloat {
		zoom: 1
	}

	.yongtou {
		float: right;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yongtou2 {
		float: left;
		width: 50px;
		height: 50px;
		border-radius: 25px;
		overflow: hidden;
	}

	.yLbox {
		margin-right: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #fdb06a;
		border-radius: 10px;
	}

	.yLbox2 {
		margin-left: 57px;
		padding: 17px 10px 17px 10px;
		line-height: 20px;
		font-size: 14px;
		background: #eee;
		border-radius: 10px;
	}

	.fasongBtn {
		width: 130px;
		height: 32px;
		text-align: center;
		line-height: 32px;
		color: #fff;
		font-size: 16px;
		border-radius: 16px;
		float: left;
		cursor: pointer;
		margin-top: 20px;
		background: #fdb06a;
		box-shadow: #f7dcc4 3px 5px 10px;
	}

	.genjilist {
		list-style: none;
		padding: 0;
	}

	.genjilist li {
		height: 35px;
		box-sizing: border-box;
		line-height: 35px;
		text-align: center;
		color: #E6BE8A;
		background: #f1f1f1;
		border-bottom: 1px solid #d2cef3;
	}
</style>
<style>
	body .el-popover {
		min-width: 50px;
		padding: 0;
	}

	.btngroup .el-radio__input {
		display: none;
	}

	.btngroup .el-radio__label {
		padding-left: 0;
	}

	.btngroup {
		display: inline-block;
		margin-right: 15px;
	}

	.yixiaolie .el-date-editor .el-range-separator {
		width: auto;
	}
</style>



// WEBPACK FOOTER //
// src/pages/ceping/yewujsuan.vue